import { IDeviceTreeGroupElement } from "@types"

export const distinctArrayOfNumber = (arrayOfNumber: number[]) => {
 return [...arrayOfNumber].filter((value: number, index: number, array) => {
  return array.indexOf(value) === index
 })
}

export const distinctArrayOfDeviceTreeGroupElements = (array: IDeviceTreeGroupElement[]) => {
 return [...array].filter(
  (device: IDeviceTreeGroupElement, index: number, self: IDeviceTreeGroupElement[]) => {
   const uniqueIdentifier = `${device.device_id}-${device.group_id}-${device.server_id}` // Create a unique identifier
   return (
    self.findIndex(
     (obj) => `${obj.device_id}-${obj.group_id}-${obj.server_id}` === uniqueIdentifier,
    ) === index
   )
  },
 )
}
